// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageDisplay {
    display: flex;
    flex-direction: row-reverse;
    width: 100%;
    border-radius: 10px;

}

.messageItem {
    background-color: rgb(255 255 255);
    padding: 15px;
    font-size: 15pt;
    font-weight: 700;
    width: 330px;
    direction: rtl;
    border-radius: 0px 0px 10px 10px;
    margin-left: 20px;
    box-shadow: 2px 2px 18px 0px #e0e0e0;
}

.logo-img-monitor {
    width: 100px;
}

.logo-cont-monitor {  

    background-color: white;
    padding: 0px 20px 0px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 2px 2px 18px 0px #6d6d6d;

}

.messagesContainer {
    display: flex;
    width: 100%;
    border-top: 7px solid red;
    flex-direction: row-reverse;
    margin-top: 20px;

}

/* MonitorMessages.css */
.messagesMonitorContainer {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 150px;
    background-color: #f1f7ff;


}

.messageList {
    display: flex;
    flex-direction: row-reverse;
    position: absolute;
    animation: scroll 50s linear infinite;


}

.messagesMonitorTitle {
    font-size: 18pt;
    font-weight: 700;
    margin-bottom: 10px;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    color: white;
    padding: 5px;

}

@keyframes scroll {
    0% {
        left: 100%;
    }

    100% {
        left: -100%;
    }
}

/* .logoContainer {
    visibility: hidden;
} */`, "",{"version":3,"sources":["webpack://./src/components/MonitorPage/MonitorMessages.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,uBAAuB;IACvB,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;;AAExC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;;AAEpB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,yBAAyB;;;AAG7B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,qCAAqC;;;AAGzC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,kFAAkF;IAClF,0BAA0B;IAC1B,YAAY;IACZ,YAAY;;AAEhB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;;GAEG","sourcesContent":[".messageDisplay {\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    width: 100%;\r\n    border-radius: 10px;\r\n\r\n}\r\n\r\n.messageItem {\r\n    background-color: rgb(255 255 255);\r\n    padding: 15px;\r\n    font-size: 15pt;\r\n    font-weight: 700;\r\n    width: 330px;\r\n    direction: rtl;\r\n    border-radius: 0px 0px 10px 10px;\r\n    margin-left: 20px;\r\n    box-shadow: 2px 2px 18px 0px #e0e0e0;\r\n}\r\n\r\n.logo-img-monitor {\r\n    width: 100px;\r\n}\r\n\r\n.logo-cont-monitor {  \r\n\r\n    background-color: white;\r\n    padding: 0px 20px 0px 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    box-shadow: 2px 2px 18px 0px #6d6d6d;\r\n\r\n}\r\n\r\n.messagesContainer {\r\n    display: flex;\r\n    width: 100%;\r\n    border-top: 7px solid red;\r\n    flex-direction: row-reverse;\r\n    margin-top: 20px;\r\n\r\n}\r\n\r\n/* MonitorMessages.css */\r\n.messagesMonitorContainer {\r\n    position: relative;\r\n    overflow: hidden;\r\n    width: 100%;\r\n    height: 150px;\r\n    background-color: #f1f7ff;\r\n\r\n\r\n}\r\n\r\n.messageList {\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    position: absolute;\r\n    animation: scroll 50s linear infinite;\r\n\r\n\r\n}\r\n\r\n.messagesMonitorTitle {\r\n    font-size: 18pt;\r\n    font-weight: 700;\r\n    margin-bottom: 10px;\r\n    border-bottom-left-radius: 100px;\r\n    border-bottom-right-radius: 100px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    color: white;\r\n    padding: 5px;\r\n\r\n}\r\n\r\n@keyframes scroll {\r\n    0% {\r\n        left: 100%;\r\n    }\r\n\r\n    100% {\r\n        left: -100%;\r\n    }\r\n}\r\n\r\n/* .logoContainer {\r\n    visibility: hidden;\r\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
